(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["athilo-journal"] && !Shopify.designMode) return;
  try {
    
  function initializeAthiloJournal(scope) {
    scope.querySelectorAll('.athilo-journal').forEach((journal) => {
      if (journal.dataset.initialized) return;
      journal.dataset.initialized = 'true';
      const navigation = journal.querySelector('.aj-filters');
      if (!navigation) return;
      const grid = journal.querySelector('.aj-articles');
      const cards = [...journal.querySelectorAll('[data-aj-card]')];
      const editorial = grid.classList.contains('aj-articles--editorial');
      const heading = journal.querySelector('.aj-more');
      const count = journal.querySelector('[data-aj-count]');
      navigation.hidden = false;
      navigation.addEventListener('click', (event) => {
        const button = event.target.closest('[data-aj-filter]');
        if (!button) return;
        const category = button.dataset.ajFilter;
        navigation.querySelectorAll('button').forEach((item) => item.setAttribute('aria-pressed', String(item === button)));
        cards.forEach((card) => { card.hidden = category !== 'all' && card.dataset.category !== category; });
        grid.classList.toggle('aj-articles--editorial', editorial && category === 'all');
        if (heading) heading.hidden = category !== 'all';
        count.textContent = cards.filter((card) => !card.hidden).length;
      });
    });
  }
  initializeAthiloJournal(document);
  document.addEventListener('shopify:section:load', () => initializeAthiloJournal(document));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));
      this.querySelectorAll('a').forEach((item) => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;
      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute(
        'aria-expanded',
        (this.elements.button.getAttribute('aria-expanded') === 'false').toString()
      );
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  function footerBlockLinkListClickHeading() {
    const footerBlockLinkListHeading = document.querySelectorAll('.footer_menus_wrapper .footer-block__heading');
    footerBlockLinkListHeading.forEach((heading) => {
      heading.addEventListener('click', () => {
        heading.parentElement.classList.toggle('active');
      });
    });
  }
  document.addEventListener('DOMContentLoaded', footerBlockLinkListClickHeading);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};
      this.resizeTimeout = null;
      this.lastKnownHeight = null;
      this.initialHeightSet = false;

      // CLS Optimization: Set initial height immediately to prevent any shift
      this.setInitialHeaderHeight();

      // CLS Optimization: Use ResizeObserver instead of resize events for better performance
      this.initializeResizeObserver();

      // CLS Optimization: Debounced media query handler
      const debouncedSetHeight = this.debounce(() => {
        this.setHeaderHeight();
      }, 150); // Slightly longer debounce for better performance

      window.matchMedia('(max-width: 990px)').addEventListener('change', debouncedSetHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    // CLS Optimization: Set initial height immediately without measuring
    setInitialHeaderHeight() {
      // Use the CSS-calculated initial height to avoid any layout shift
      const initialHeight = getComputedStyle(document.documentElement).getPropertyValue('--header-height-initial').trim();
      this.lastKnownHeight = parseInt(initialHeight);
      this.initialHeightSet = true;
    }

    // CLS Optimization: Initialize ResizeObserver for efficient resize handling
    initializeResizeObserver() {
      if (!window.ResizeObserver) {
        // Fallback for browsers without ResizeObserver support
        window.addEventListener('resize', this.debounce(() => {
          this.setHeaderHeight();
        }, 150));
        return;
      }

      this.resizeObserver = new ResizeObserver(entries => {
        // Use requestAnimationFrame to batch updates
        requestAnimationFrame(() => {
          this.setHeaderHeight();
        });
      });

      // Observe the header for size changes
      this.resizeObserver.observe(this.header);
    }

    setHeaderHeight() {
      // CLS Optimization: Only update if height actually changed to prevent unnecessary reflows
      const currentHeight = this.header.offsetHeight;
      
      // Skip if height hasn't changed significantly (allow 1px tolerance for subpixel rendering)
      if (Math.abs(this.lastKnownHeight - currentHeight) <= 1) {
        return;
      }

      this.lastKnownHeight = currentHeight;
      
      // Use requestAnimationFrame to batch DOM writes and prevent layout thrashing
      requestAnimationFrame(() => {
        // CLS Optimization: Only update if the difference is significant enough to matter
        const currentCSSHeight = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--header-height'));
        if (Math.abs(currentCSSHeight - currentHeight) > 2) {
          document.documentElement.style.setProperty('--header-height', `${currentHeight}px`);
        }
      });
    }

    // CLS Optimization: Debounce utility to prevent excessive function calls
    debounce(func, wait) {
      return (...args) => {
        clearTimeout(this.resizeTimeout);
        this.resizeTimeout = setTimeout(() => func.apply(this, args), wait);
      };
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
      
      // CLS Optimization: Clean up ResizeObserver and timeouts to prevent memory leaks
      if (this.resizeObserver) {
        this.resizeObserver.disconnect();
        this.resizeObserver = null;
      }
      
      if (this.resizeTimeout) {
        clearTimeout(this.resizeTimeout);
        this.resizeTimeout = null;
      }
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
